/**
 * Mainbeauty — cuộn mượt cho anchor cùng trang, trừ hụt chiều cao header.
 */
import lenis from "./smoothScroll.js";

const HEADER_GAP = 16; // khoảng thở giữa header sticky và mục được cuộn tới

// href="#..." của Bootstrap/Owl và [data-pi-consult-open] chỉ là hook, không cuộn.
const CONTROL_HOOKS =
  "[data-toggle],[data-target],[data-slide],[data-slide-to],[data-dismiss],[data-pi-consult-open]";

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

// Thanh dính trên đầu trang: header PI, hoặc header riêng của landing.
function headerOffset() {
  const bars = document.querySelectorAll(".hdr, [data-pi-lp-nav]");
  return Array.from(bars).reduce((sum, bar) => sum + bar.offsetHeight, 0) + HEADER_GAP;
}

function scrollToTarget(target, immediate) {
  lenis.scrollTo(target, {
    offset: -headerOffset(),
    immediate: immediate || reducedMotion.matches,
  });
}

// Cùng trang = cùng path + cùng query; khác đi là điều hướng thật.
function isSamePage(url) {
  return (
    url.pathname === window.location.pathname &&
    url.search === window.location.search
  );
}

function onClick(e) {
  if (e.defaultPrevented || e.button !== 0) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  const link = e.target.closest('a[href*="#"]');
  if (!link || link.matches(CONTROL_HOOKS) || link.target === "_blank") return;

  const url = new URL(link.href, window.location.href);
  if (!isSamePage(url)) return;

  const id = decodeURIComponent(url.hash.slice(1));
  const target = id && document.getElementById(id);
  if (!target) return;

  e.preventDefault();
  scrollToTarget(target);
  window.history.pushState(null, "", url.hash);
}

// Sang từ trang khác, trình duyệt đã nhảy sẵn tới đích: lùi một đoạn rồi trôi xuống.
const LANDING_RUNUP = 280;

function onLoad() {
  const id = decodeURIComponent(window.location.hash.slice(1));
  const target = id && document.getElementById(id);
  if (!target) return;

  if (reducedMotion.matches) {
    requestAnimationFrame(() => scrollToTarget(target, true));
    return;
  }

  requestAnimationFrame(() => {
    const top =
      target.getBoundingClientRect().top + window.scrollY - headerOffset();
    lenis.scrollTo(Math.max(0, top - LANDING_RUNUP), { immediate: true });
    requestAnimationFrame(() => scrollToTarget(target));
  });
}

document.addEventListener("click", onClick);
window.addEventListener("load", onLoad);
